//Read more functionality for custom section 
document.addEventListener("DOMContentLoaded", function () {
  let content = document.querySelector(".read-more-content");
  let btn = document.querySelector(".read-more-btn");

  if (content && btn) {
    let lineHeight = parseFloat(getComputedStyle(content).lineHeight);
    let maxVisibleHeight = lineHeight * 3; // Approximate height for 3 lines

    // Hide button if content is empty or short
    if (!content.textContent.trim() || content.scrollHeight <= maxVisibleHeight) {
      btn.style.display = "none";
      return;
    }

    btn.addEventListener("click", function () {
      if (content.classList.contains("expanded")) {
        content.classList.remove("expanded");
        content.style.maxHeight = "";
        btn.textContent = "Read More";
      } else {
        content.classList.add("expanded");
        content.style.maxHeight = content.scrollHeight + "px";
        btn.textContent = "Read Less";
      }
    });
  }
});


// Open links on new tab
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".cus_store_link .swiper-slide a").forEach(function(link) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
    });
});
